import { render } from "./CustomFieldInputKeyValue.vue?vue&type=template&id=720d4bca&scoped=true"
import script from "./CustomFieldInputKeyValue.vue?vue&type=script&lang=js"
export * from "./CustomFieldInputKeyValue.vue?vue&type=script&lang=js"

import "./CustomFieldInputKeyValue.vue?vue&type=style&index=0&id=720d4bca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-720d4bca"]])

export default __exports__